import { MouseEventHandler } from 'react';

import TextBaseFieldPlaceholder, {
  TextBaseFieldPlaceholderProps,
} from '@app/features/apply-react-signing/components/FieldSetupStep/Placeholders/TextBaseFieldPlaceholder';

export interface TextFieldPlaceholderProps extends Omit<TextBaseFieldPlaceholderProps, 'value'> {}

const defaultProps = {
  rootElementSize: null,
  onMouseDown(_event: MouseEventHandler<HTMLDivElement>) {},
};

function CompanyNameFieldPlaceholder(props: TextFieldPlaceholderProps) {
  return <TextBaseFieldPlaceholder {...props} value="#회사 이름" />;
}

CompanyNameFieldPlaceholder.defaultProps = defaultProps;

export default CompanyNameFieldPlaceholder;
